/**
 * metaWire.js - FALLBACK twin of proxy-server/sdkBidding/metaWire.js (the one parse of Meta's
 * rendering_data and network_ads_common wire shapes). Pinned field by field against the proxy
 * module by metaWireParity.test.js. Port of these three functions only: the frontend never had
 * validateGAMRequest / validateSDKBidding. Never throws.
 */

const has = (o, k) => !!o && Object.prototype.hasOwnProperty.call(o, k);
const str = (v) => (v == null || v === '' ? null : String(v));

export function parseRenderingData(rd) {
  const none = { bidId: null, placementId: null, resolvedPlacementId: null };
  try {
    const o = typeof rd === 'string' ? JSON.parse(rd) : rd;
    if (!o || typeof o !== 'object') return none;
    return {
      bidId: str(o.bid_id),
      placementId: str(o.placement_id),
      resolvedPlacementId: str(o.resolved_placement_id),
    };
  } catch { return none; }
}

const numOrNull = (v) => {
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export function parseMetaAdRequest(url = '', requestBody = '', responseBody = '') {
  try {
    const u = String(url == null ? '' : url);
    if (!/network_ads_common/.test(u)) return null;
    const q = u.includes('?') ? u.slice(u.indexOf('?') + 1) : '';
    const form = new URLSearchParams(`${q}&${typeof requestBody === 'string' ? requestBody : ''}`);
    const bidId = form.get('BID_ID');
    if (!bidId && !form.get('PLACEMENT_ID')) return null;
    const resp = typeof responseBody === 'string' ? responseBody : '';
    let code = null;
    const m = resp.match(/"code"\s*:\s*(\d+)/);
    if (m) code = Number(m[1]);
    let definition = null;
    try {
      const d = JSON.parse(resp).placements[0].definition;
      if (d && typeof d === 'object') definition = { placementId: str(d.placement_id), type: str(d.type) };
    } catch { definition = null; }
    return {
      bidId: bidId || null,
      placementId: form.get('PLACEMENT_ID') || null,
      testMode: form.get('TEST_MODE') === '1',
      code,
      templateId: str(form.get('TEMPLATE_ID')),
      width: numOrNull(form.get('WIDTH')),
      height: numOrNull(form.get('HEIGHT')),
      definition,
    };
  } catch { return null; }
}

const isGamRow = (row, url) => row.requestType === 'google'
  || (/\/gampad\/ads\?/.test(url) && /doubleclick\.net/.test(url));
const isMetaRow = (url) => /network_ads_common/.test(url) && /facebook\.com/.test(url);

export function stampWireFields(row) {
  try {
    if (!row || typeof row !== 'object' || row.captureSource === 'logcat') return row;
    const url = typeof row.url === 'string' ? row.url : '';
    const resp = typeof row.responseBody === 'string' ? row.responseBody : '';
    const vd0 = row.validData && typeof row.validData === 'object' ? row.validData : null;

    if (resp && isGamRow(row, url)) {
      const ex = vd0 && vd0.expanded && typeof vd0.expanded === 'object' ? vd0.expanded : null;
      if (!has(ex, 'sdkPlacementId')) {
        let p = null;
        try { p = parseRenderingData(JSON.parse(resp).ad_networks[0].buyer_sdk_ad.rendering_data); } catch { p = null; }
        if (p && (p.bidId || p.placementId || p.resolvedPlacementId)) {
          const next = { ...(ex || {}) };
          if (!has(next, 'sdkBidId')) next.sdkBidId = p.bidId;
          next.sdkPlacementId = p.placementId;
          next.sdkResolvedPlacementId = p.resolvedPlacementId;
          row.validData = { ...(vd0 || {}), expanded: next };
        }
      }
    }

    if (isMetaRow(url)) {
      const vd = row.validData && typeof row.validData === 'object' ? row.validData : null;
      const old = vd && vd.metaAdRequest && typeof vd.metaAdRequest === 'object' ? vd.metaAdRequest : null;
      if (!has(old, 'definition')) {
        const m = parseMetaAdRequest(url, row.requestBody, resp);
        if (m) {
          if (m.code == null && old && old.code != null) m.code = old.code;
          row.validData = { ...(vd || {}), metaAdRequest: m };
        }
      }
    }
  } catch { /* never throws */ }
  return row;
}
